import React from 'react';
import { withRouter } from 'react-router-dom';

// This is a component to scroll to top of window for every location change
// This is so any react router change will scroll to top of the window
export class ScrollToTop extends React.Component {
  componentDidUpdate(prevProps) {
    if (this.props.location.pathname !== prevProps.location.pathname) {
      window.scrollTo(0, 0);
    }
  }

  render() {
    return this.props.children;
  }
}

export default withRouter(ScrollToTop);
